"use client"

import Link from "next/link"
import { motion } from "framer-motion"
import { Github, Send } from "lucide-react"

const socialLinks = [
    {
        name: "Facebook",
        href: "https://www.facebook.com/tokenkickstarter/",
        icon: (
            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
            </svg>
        ),
        color: "hover:bg-[#1877F2]/20 hover:text-[#1877F2]",
    },
    {
        name: "X (Twitter)",
        href: "https://x.com/TokenKickstart",
        icon: (
            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
        ),
        color: "hover:bg-foreground/20 hover:text-foreground",
    },
    {
        name: "TikTok",
        href: "https://www.tiktok.com/@tokenkickstarter",
        icon: (
            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
            </svg>
        ),
        color: "hover:bg-[#ff0050]/20 hover:text-[#ff0050]",
    },
    {
        name: "GitHub",
        href: "https://github.com/TokenKickstarter",
        icon: <Github className="h-5 w-5" />,
        color: "hover:bg-foreground/20 hover:text-foreground",
    },
    {
        name: "Medium",
        href: "https://medium.com/@TokenKickstarter",
        icon: (
            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M13.54 12a6.8 6.8 0 01-6.77 6.82A6.8 6.8 0 010 12a6.8 6.8 0 016.77-6.82A6.8 6.8 0 0113.54 12zM20.96 12c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z" />
            </svg>
        ),
        color: "hover:bg-foreground/20 hover:text-foreground",
    },
    {
        name: "Reddit",
        href: "https://www.reddit.com/user/Token_Kickstarter/",
        icon: (
            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z" />
            </svg>
        ),
        color: "hover:bg-[#FF4500]/20 hover:text-[#FF4500]",
    },
    {
        name: "Telegram",
        href: "https://t.me/tokenkickstarter",
        icon: <Send className="h-5 w-5" />,
        color: "hover:bg-[#0088cc]/20 hover:text-[#0088cc]",
    },
]

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.05,
            delayChildren: 0.1,
        },
    },
}

const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.35, ease: "easeOut" as const },
    },
}

export function SocialSection() {
    return (
        <section className="py-16 sm:py-20 relative overflow-hidden">
            {/* Background gradient */}
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/5 to-transparent pointer-events-none" />

            <div className="container relative">
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-50px" }}
                    variants={containerVariants}
                    className="text-center"
                >
                    {/* Section Header */}
                    <motion.div variants={itemVariants} className="mb-10">
                        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
                            Join Our <span className="text-primary">Community</span>
                        </h2>
                        <p className="text-muted-foreground max-w-xl mx-auto">
                            Stay connected and be part of the TokenKickstarter ecosystem. Follow us for updates, news, and community discussions.
                        </p>
                    </motion.div>

                    {/* Social Icons Grid */}
                    <motion.div
                        variants={containerVariants}
                        className="flex flex-wrap justify-center gap-4 sm:gap-5"
                    >
                        {socialLinks.map((social) => (
                            <motion.div key={social.name} variants={itemVariants}>
                                <Link
                                    href={social.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`
                                        group flex flex-col items-center gap-2 p-4 sm:p-5
                                        rounded-2xl bg-card/50 backdrop-blur-sm
                                        border border-border/50 hover:border-primary/30
                                        transition-all duration-300 hover:scale-105
                                        hover:shadow-lg hover:shadow-primary/10
                                        ${social.color}
                                    `}
                                >
                                    <div className="flex items-center justify-center h-12 w-12 rounded-xl bg-muted/50 group-hover:bg-current/10 transition-colors">
                                        <span className="text-foreground group-hover:scale-110 transition-transform">
                                            {social.icon}
                                        </span>
                                    </div>
                                    <span className="text-xs sm:text-sm font-medium text-muted-foreground group-hover:text-foreground transition-colors">
                                        {social.name}
                                    </span>
                                </Link>
                            </motion.div>
                        ))}
                    </motion.div>

                    {/* Optional CTA */}
                    <motion.p
                        variants={itemVariants}
                        className="mt-10 text-sm text-muted-foreground"
                    >
                        Have questions?{" "}
                        <Link href="/contact" className="text-primary hover:underline underline-offset-4">
                            Contact us
                        </Link>
                    </motion.p>
                </motion.div>
            </div>
        </section>
    )
}

export default SocialSection
